import $ from 'jquery';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-increase-decrease]';
const INCREASE_ELEMENT_SELECTOR = '[data-increase-decrease-increase]';
const DECREASE_ELEMENT_SELECTOR = '[data-increase-decrease-decrease]';
const INPUT_ELEMENT_SELECTOR = '[data-increase-decrease-input]';
const PLUGIN_NAME = 'increaseDecrease';

class IncreaseDecrease {
	constructor(element, options) {
        this.$element = $(element);
        this.$increase = this.$element.find(INCREASE_ELEMENT_SELECTOR);
        this.$decrease = this.$element.find(DECREASE_ELEMENT_SELECTOR);
        this.$input = this.$element.find(INPUT_ELEMENT_SELECTOR);
        this.watch();
    }

    processInput(increase) {
        var val = this.$input.val();
        var valInt = parseInt(val);
        if (valInt < 0 || isNaN(valInt) || val.length == 0) {
         valInt =1;
        }
        else if (increase) {
         valInt = valInt + 1;
        }
        else if (valInt > 0){
            valInt = valInt - 1;
        }

        this.$input.val(valInt);
    }

    processInputVal() {
        var val = this.$input.val();
        var valInt = parseInt(val);
        if (valInt < 0 || isNaN(valInt) || val.length == 0) {
         valInt =1;
        }

        this.$input.val(valInt);
    }

    watch() {
        var mod = this;
        this.$increase.on('click', function () {
           mod.processInput(true);
        });

        this.$decrease.on('click', function () {
            mod.processInput(false);
        });

        this.$input.on('change', function () {
            mod.processInputVal();
        });
    }
}

IncreaseDecrease.DEFAULTS = {};
plugin(PLUGIN_NAME, IncreaseDecrease);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/increase-decrease.js